import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDde7XXCiZQowDvtND66PshzME3aM7bA5E",
  authDomain: "indiahiring-2bc5d.firebaseapp.com",
  projectId: "indiahiring-2bc5d",
  storageBucket: "indiahiring-2bc5d.firebasestorage.app",
  messagingSenderId: "1022207017822",
  appId: "1:1022207017822:web:a74805cf56a3cd7117c5cf",
  measurementId: "G-XBC3X94T3B"
};

// Initialize Firebase 
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

const setupRecaptcha = () => {
  // Clear existing verifier if any
  if (window.recaptchaVerifier) {
    window.recaptchaVerifier.clear();
  }

  window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
    size: "invisible",
    callback: () => {
      // Recaptcha verified callback (intentionally left empty for production)
    },
    "expired-callback": () => {
      // Clear and reinitialize on expiry
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;
      }
    }
  });
};

export { auth, googleProvider, setupRecaptcha, RecaptchaVerifier, signInWithPhoneNumber };